import apiService from "./apiService";
import AppConstants from "../appConstants";

class CharacteristicService {
    getAllCharacteristic(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CHARACTERISTIC, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getCharacteristicDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_CHARACTERISTIC}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerCharacteristic(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_CHARACTERISTIC, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteCharacteristic(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_CHARACTERISTIC}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_CHARACTERISTIC_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new CharacteristicService();
